import React from 'react';
import Button from '@mui/material/Button';
import {
  alpha,
  useTheme,
  type SxProps,
  type Theme,
} from '@mui/material/styles';

interface RunningBulkOpButtonProps {
  disabled?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export default function RunningBulkOpButton({
  disabled = false,
  onClick,
}: Readonly<RunningBulkOpButtonProps>) {
  const theme = useTheme();

  const sx: SxProps<Theme> = {
    height: 28,
    width: 130,
    minWidth: 130,
    borderRadius: '4px',
    border: `1px solid ${theme.palette.semantic.hyperlink.active}`,
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.semantic.hyperlink.active,
    fontSize: '0.75rem',
    fontWeight: 500,
    textTransform: 'none',
    paddingX: 1,
    ':hover': {
      borderColor: theme.palette.semantic.hyperlink.active,
      color: theme.palette.semantic.hyperlink.active,
    },
    '&.Mui-disabled': {
      border: `1px solid ${alpha(theme.palette.action.disabled, 0.3)}`,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.action.disabled,
    },
  };

  return (
    <Button
      variant="outlined"
      size="small"
      disabled={disabled}
      disableRipple={disabled}
      onClick={onClick}
      sx={sx}
    >
      Bulk Op Running...
    </Button>
  );
}
